import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { Answer } from "types";
import type { RootState } from "../store";

// Define a type for the slice state
interface AddAnswerState {
  id: number;
  content: string;
  isCorrect: string;
  addedOn: Date;
  lastModifiedOn: Date | null;
  questionId: number;
  answers: Answer[];
}

// Define the initial state using that type
const initialState: AddAnswerState = {
  content: "",
  isCorrect: "",
  addedOn: new Date(),
  id: 0,
  lastModifiedOn: new Date(),
  questionId: 0,
  answers: [],
};

export const addAnswerSlice = createSlice({
  name: "addAnswer",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
    setContent: (state, action: PayloadAction<string>) => {
      state.content = action.payload;
    },
    setAnswers: (state, action: PayloadAction<Answer[]>) => {
      state.answers = action.payload;
    },
    setIsCorrect: (state, action: PayloadAction<string>) => {
      state.isCorrect = action.payload;
    },
  },
});

export const { setContent, setIsCorrect, setAnswers } = addAnswerSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const getAddAnswerData = (state: RootState) => state.addAnswer;
export default addAnswerSlice.reducer;
